import { render, staticRenderFns } from "./DistributorItemDetail.vue?vue&type=template&id=e679d9ba&"
import script from "./DistributorItemDetail.vue?vue&type=script&lang=js&"
export * from "./DistributorItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports